/** Request body aligned with Umbraco `SubscribeRequestViewModel`. */
export interface SubscribeRequestBody {
    newsletterKeys: string[];
    partners: boolean;
    rsid?: string;
    source?: string;
    track1?: string;
    firstName?: string;
    lastName?: string;
}

export function buildSubscribeRequestBody(
    identifiers: string[],
    options: {
        partners: boolean;
        rsid?: string;
        source?: string;
        track1?: string;
        firstName?: string;
        lastName?: string;
    }
): SubscribeRequestBody | null {
    const trimmed = identifiers.map((id) => String(id).trim()).filter(Boolean);
    if (trimmed.length === 0) {
        return null;
    }

    return {
        newsletterKeys: trimmed,
        partners: options.partners,
        rsid: options.rsid,
        source: options.source,
        track1: options.track1,
        firstName: options.firstName,
        lastName: options.lastName
    };
}
